import React from "react"
import { IConversationBubble } from "./model"

import "./style.scss"

export const ConversationBubble = (props: IConversationBubble) => {
    const { header, para } = props

    return (
        <div className="cvs">
            <div>
                <h2>{header}</h2>
                <p>{para}</p>
            </div>
            <div>
                <img
                    src="https://blackpearlmail.com/wp-content/uploads/2022/10/conversational-face.png"
                    className="mobile-only"
                />
            </div>
        </div>
    )
}
